import unCamelCase from '@/common/helpers/un-camel-case';

export default class FilterOptionsBuilder {
    /**
     * Initialize the builder for the provided filter set.
     * @param {FilterSet} filterSet
     */
    constructor(filterSet) {
        this.filterSet = filterSet;
    }

    /**
     * Build a list of options while excluding already selected pointers and including
     * the currently active pointer for the line.
     * @param {string[]} selectedPointers
     * @param {string} currentPointer
     * @return {{}[]}
     */
    build({selectedPointers, pointer: currentPointer}) {
        const {combinedFilters = {}} = this.filterSet;
        return Object
            .keys(combinedFilters)
            // exclude already selected filters except for the current pointer
            .filter(pointer => pointer === currentPointer || !selectedPointers.includes(pointer))
            .sort()
            .reduce((acc, pointer) => [...acc, FilterOptionsBuilder.createOption(pointer)], []);
    }

    /**
     * Create a v-select option from the pointer.
     * @param {string} pointer
     * @return {{label: string, value: string}}
     */
    static createOption(pointer) {
        return {
            value: pointer,
            label: FilterOptionsBuilder.getLabelFromPointer(pointer),
        };
    }

    /**
     * Generate a label from the pointer regardless of the delimiter that was used.
     * @param {string} pointer
     * @return {string}
     */
    static getLabelFromPointer(pointer) {
        const delimiter = pointer.indexOf('.') > -1 ? '.' : '/';
        return pointer.split(delimiter)
            .map(unCamelCase)
            .join(' ');
    }
}
